// 加班單一律視為同一天內的區間，不處理跨日。
// 開始與結束時間只取時分，日期一律固定成申請日期（該筆排班的 expectedDate）。
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}/;

function toMoment(value) {
  if (value === null || value === undefined || value === '') return null;
  if (moment.isMoment(value)) return value.isValid() ? value : null;
  const parsed = moment(value);
  return parsed.isValid() ? parsed : null;
}

// 一天之內的分鐘數，只看時分
function minutesOfDay(value) {
  const target = toMoment(value);
  if (!target) return null;
  return (target.hours() * 60) + target.minutes();
}

// 申請日期以排班日 date 為準；舊資料沒帶 date 時退回開始時間的日期
export function getOvertimeBaseDate(overtime = {}) {
  const { date, startAt } = overtime;
  if (typeof date === 'string' && DATE_PATTERN.test(date)) return date.slice(0, 10);

  const start = toMoment(startAt);
  return start ? start.format(DATE_FORMAT) : '';
}

// 畫面顯示與送出前檢核共用的算法，跟實際存檔的值一致。
// 結束時分早於開始時分會回傳負值，由呼叫端擋下。
export function getOvertimeMinutes(overtime = {}) {
  const start = minutesOfDay(overtime.startAt);
  const end = minutesOfDay(overtime.endAt);
  if (start === null || end === null) return null;
  return end - start;
}

// 組出要送給後端的 startAt / endAt，日期一律換成申請日期
export function buildOvertimeRange(overtime = {}, timeFormat = 'HH:mm') {
  const baseDate = getOvertimeBaseDate(overtime);
  const start = toMoment(overtime.startAt);
  const end = toMoment(overtime.endAt);
  if (!baseDate || !start || !end) return null;

  return {
    startAt: `${baseDate} ${start.format(timeFormat)}`,
    endAt: `${baseDate} ${end.format(timeFormat)}`,
  };
}
